import { ISelectOption } from '../../../../../web/components/DeprecatedSelect';
import { FieldKey } from '../../../../viewModels/form';
import { IOptionItem } from '../../../LeadRuleModal/types';
import { IPhoneCallOutcomeGroup } from '../../../../viewModels/phonecall';

export const reduceChildren = (accumulator: any, item: ISelectOption<FieldKey>) => {
	return item?.children ? accumulator?.concat(item?.children) : [];
};

export const filterByChecked = (item: ISelectOption<FieldKey>) => item.checked;

export const checkAll = (checked: boolean, defaultValues?: string[]) => (parent: ISelectOption<FieldKey>) => {
	parent.checked = checked;
	parent?.children?.map((child: ISelectOption<FieldKey>) => {
		if (defaultValues && defaultValues?.indexOf(child.name) !== -1) {
			child.checked = true;
			return child;
		}
		child.checked = checked;
		return child;
	});
	if (defaultValues && parent?.children?.filter(filterByChecked)?.length === parent?.children?.length) {
		if (parent.name !== 'all') {
			parent.checked = true;
		}
	}
	return parent;
};

export const prepareResponse = (item: any) => {
	const opt: ISelectOption<FieldKey> = {
		checked: true,
		children: item.children,
		dataContext: item.name,
		id: item.name,
		name: item.name,
		text: item.label,
	};
	return opt;
};

const cloneOptions = (options: IOptionItem<FieldKey>[]): IOptionItem<FieldKey>[] =>
	options.map(option => ({
		...option,
		children: option.children?.map((child: IOptionItem<FieldKey>) => ({ ...child })),
	}));

// Builds the checklist from the server's groups. Clones them so the query cache never changes.
export const buildOutcomeOptions = (
	groups: IPhoneCallOutcomeGroup[],
	defaultValues: string[]
): IOptionItem<FieldKey>[] => {
	const options = cloneOptions(groups.map(prepareResponse));
	options.unshift({
		checked: true,
		dataContext: FieldKey.Unknown,
		id: 'all',
		name: 'all',
		text: 'All outcome types',
	});
	return options.map(checkAll(false, defaultValues));
};

const markChildren = (parent: IOptionItem<FieldKey>, target: { checked: boolean; id: string }) => {
	if (parent.id === target.id) {
		parent.checked = target.checked;
	}
	parent.children?.forEach((child: IOptionItem<FieldKey>) => {
		if (!Object.prototype.hasOwnProperty.call(Object(child), 'checked')) {
			child.checked = true;
		}
		if (parent.id === target.id) {
			child.checked = target.checked;
		}
		if (child.id === target.id) {
			child.checked = target.checked;
			if (!target.checked) {
				parent.checked = false;
			}
		}
	});
	if (parent.children?.filter(filterByChecked).length === parent.children?.length) {
		parent.checked = true;
	}
	return parent;
};

export const toggleOutcome = (
	options: IOptionItem<FieldKey>[],
	id: string,
	checked: boolean
): IOptionItem<FieldKey>[] => {
	const next = cloneOptions(options).map(
		id === 'all' ? checkAll(checked) : parent => markChildren(parent, { checked, id })
	);
	const allChecked = next.filter(filterByChecked).length === next.length;
	next.forEach(parent => {
		if (parent.id === 'all') {
			parent.checked = allChecked;
		}
	});
	return next;
};
